var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,61.7c1.2-4.5,2.2-9.1,3.8-13.5C18.6,23.6,41,7.2,67,7.1C129.5,6.8,192,6.9,254.4,7c12.4,0,21.3,8.9,21.3,20.6 s-8.6,20.5-21.2,20.6c-26,0.2-52.1,0.1-78.1,0.1c-35,0-70,0-104.9,0c-8.5,0-16.3,1.9-20.4,9.8c-2.3,4.8-3.5,10-3.4,15.4 c-0.2,80.2-0.2,160.4-0.1,240.6c0,41.8,0,83.6,0,125.4c0,7.3,1.4,13.9,7.1,18.9c5,4.4,11,5.3,17.3,5.3c59.5,0,119.1,0,178.6,0 c3.1-0.1,6.2,0,9.2,0.5c10,2.1,16.6,11.4,15.8,22.1c-0.9,10-8.8,17.8-18.8,18.6c-1.3,0.1-2.6,0.1-3.9,0.1c-61.2,0-122.3,0-183.5,0 c-30.7-0.1-54.9-19.3-61.9-48.8c-0.5-2-1-4-1.6-6V61.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.4,276.7h-7.1c-77.3,0-154.6-0.1-231.9,0.1c-14.2,0-21.6-8.9-23.1-17.4c-2-11.4,6.6-22.9,18.2-23.9 c2.4-0.2,4.9-0.2,7.3-0.2h236.4c-2-2.2-3.3-3.5-4.6-4.8c-27.8-27.4-55.6-54.9-83.4-82.3c-6.1-6-9.5-12.7-7.5-21.4 c2.5-11.1,13.5-18.1,24.6-15.5c2.8,0.6,5.4,1.8,7.7,3.5c1.8,1.4,3.5,2.9,5.1,4.6c40.3,39.8,80.6,79.5,120.9,119.3 c11.8,11.6,11.8,23,0,34.6c-40.5,40-81,80-121.6,120c-9.5,9.3-20.2,10.6-29.3,3.5c-9-6.8-10.7-19.7-3.9-28.6 c0.1-0.2,0.2-0.3,0.4-0.5c1.5-1.8,3-3.4,4.6-5c27.5-27.2,55.1-54.4,82.7-81.6C431.2,280,432.3,278.9,434.4,276.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/Icon_Logout.9418a8dd52493d586dbebf3432423640.svg";
export { ForwardRef as ReactComponent };